import React, { useState } from "react";
import { send } from '@emailjs/browser';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./Contact.css";

const Contacto = () => {
  // Estado para almacenar los datos del formulario
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    category: "",
    comment: "",
  });

  // Maneja los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Maneja el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();

    // Reemplaza estos valores con tus IDs de EmailJS
    const serviceID = "service_cngroup_test"; // Ej: "service_abc123"
    const templateID = "template_cngroup_test"; // Ej: "template_xyz456"
    const publicKey = "TgxikQIdYHI3IV4ZG"; // Tu clave pública de EmailJS

    // Envía el formulario usando EmailJS
    send(serviceID, templateID, formData, publicKey)
      .then((response) => {
        console.log("Email enviado con éxito!", response.status, response.text);
        alert("¡Mensaje enviado con éxito!");
        // Limpia el formulario después del envío
        setFormData({
          name: "",
          email: "",
          phone: "",
          category: "",
          comment: "",
        });
      })
      .catch((error) => {
        console.error("Error al enviar el email:", error);
        alert("Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo.");
      });
  };

  return (
    <div className="contacto-page">
      {/* Fondo que cubre toda la pantalla detrás del navbar */}
      <div className="background-container-contact"></div>

      <Navbar />
      
      {/* Sección del banner con texto */}
      <div className="contacto-banner">
        <div className="contact-text">
          <h1 className="contact-title">Contacta con Nosotros</h1>
          <p className="contact-subtitle">
            ¿Tiene alguna pregunta? Contáctenos y un miembro de nuestro equipo se comunicará con usted lo antes posible.
          </p>
        </div>
      </div>

      {/* Sección del formulario con fondo blanco */}
      <div className="contacto-content">
        <div className="contacto-form-section">
          <div className="intro-text">
            <h2>Cuéntanos qué desea y un miembro de nuestro equipo se comunicará con usted lo antes posible.</h2>
            <p className="intro-description">
              Dedicamos nuestra actividad a la mejora de la calidad de la energía, ya que posibilita a nuestros clientes
              la implementación y el uso comercial de la energía fotovoltaica. Para obtener más detalles sobre lo que
              podemos ofrecerle, diríjase a las distintas secciones de nuestro sitio web y así poder iniciar la conversación.
            </p>
          </div>
          
          <div className="contacto-form-container">
            <div className="contacto-form">
              <form onSubmit={handleSubmit}>
                <div className="input-group">
                  <label className="input-label">Nombre y Apellidos</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Tu nombre y apellidos"
                    required
                  />
                </div>
                <div className="input-row">
                  <div className="input-group">
                    <label className="input-label">Correo Electrónico</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Tu correo"
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label">Número de Teléfono</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Tu teléfono"
                    />
                  </div>
                </div>
                <div className="input-group">
                  <label className="input-label">Categoría de la pregunta/Tipo de pregunta</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Seleccione una categoría</option>
                    <option value="Servicio">Servicio</option>
                    <option value="Soporte Técnico">Soporte Técnico</option>
                    <option value="Colaboración">Colaboración</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                <div className="input-group">
                  <label className="input-label">Comentario</label>
                  <textarea
                    name="comment"
                    value={formData.comment}
                    onChange={handleChange}
                    placeholder="Escribe tu mensaje"
                    rows="7"
                    required
                  ></textarea>
                </div>
                <button type="submit">Enviar mensaje</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contacto;